import GeneralHelper from "./generalHelper"
import Thumbnail from "./thumbnail"
import Favorites from "./favorites"
import MetaFiles, { Type } from "./metafiles"
import ColorHelper from "./colorHelper"
import View from "./View"
import PatternBuilderCart from "./PatternBuilderCart"

export default class Pattern
{
  static get_category_patterns$(docs)
  {
    var filtered = Cx_.filter(docs, function(doc) { return ( ( doc.Class2 !== METAFILE.TYPE.logo_document ) && ( doc.Class2 !== METAFILE.TYPE.header_document ) ); });
    return ( filtered != undefined ) ? ( ! Array.isArray(filtered ) ) ? [filtered] : filtered : filtered ;
  }

  static get_category_non_patterns(docs)
  {
    var filtered = Cx_.filter(docs, function(doc) { return ( ( doc.Class2 === METAFILE.TYPE.logo_document ) || ( doc.Class2 === METAFILE.TYPE.header_document ) ); });
    return ( filtered != undefined ) ? ( ! Array.isArray(filtered ) ) ? [filtered] : filtered : filtered ;
  }

  static process(element, patterns) {
    if ( patterns.length > 0 )
      Thumbnail.load_main_thumbnails(element, patterns);
  }

  static load_category_patterns$(pattern_set) {
    var deferred = new Cx$.Deferred();
    if (pattern_set.length == 0)
      return;
    let searchModel = {
      Match: {
        Owned: false,
        Shared: true,
        Tags: [{ Name: pattern_set, Owned: true, Shared: true }],
        Archived: false
      }
      , IncludeData: true
    }
    Cadx.Core.Document.search$(searchModel).then(function (response_model) {
      deferred.resolve(Pattern.get_category_patterns$(response_model.Items));
    });
    return deferred;
  }

  static list_raster_children_documents$(target)
  {
    $('#' + target).empty();
    let color_tuples = [];

    var p = ( window.AppInstance.instance().selected.parent !== null ) ? window.AppInstance.instance().selected.parent : window.AppInstance.instance().selected ;

    //main color set
    Thumbnail.render_color_thumb_img$(p.id
      , null
      , false
      , p.metadata.get('thumbZoom')
      , p.metadata.get('thumbWidth')
      , p.metadata.get('thumbHeight')
      , p.metadata.get('thumbDPI')
      , true
      ).then(function(thumb){
        var thumb_html = '<div class="colorway ' + (window.AppInstance.instance().selected.ExternalId.replace('production-', '') === p.ExternalId ? "active" : "") + '" onclick="window.load_pattern_and_metafiles(\'' + p.ExternalId + '\', false);"><img src="' + thumb + '" width="65px" height="65px" class="main-thumb" /></div></div>';
        $('#' + target).append(thumb_html);
      })
      .catch(function(e) {
        GeneralHelper.errorOut(e);
      });

      //toggleColorwayCopy(target);

    if (p.metadata.get('colorSet') != 'undefined') {
      var color_docs = JSON.parse( p.metadata.get('colorSet') );
      Cx_.forEach(color_docs, function (doc_id, i) {
        var searchModel = {
          Owned: false,
          Shared: true,
          Id: (typeof doc_id === 'object' ) == true ? doc_id.Id : doc_id,
          Archived: false
        };
        Cadx.Core.Document.read$(searchModel).then(function (response_model) {
          let Id = (typeof doc_id === 'object' ) == true ? doc_id.Id : doc_id ;

            Thumbnail.render_color_thumb_img$(Id
            , null
            , false
            , p.metadata.get('thumbZoom')
            , p.metadata.get('thumbWidth')
            , p.metadata.get('thumbHeight')
            , p.metadata.get('thumbDPI')
            , true
            ).then(function(thumb) {
              var thumb_html = '<div class="colorway ' + (window.AppInstance.instance().selected.ExternalId.replace('production-', '') === response_model.ExternalID.replace('production-', '') ? "active" : "") + '" onclick="window.load_pattern_and_metafiles(\'' + response_model.ExternalID + '\', false);"><img width="65px" height="65px" src="' + thumb + '" /></div></div>';
              $('#' + target).append(thumb_html);
              View.resize();
            })
            .catch(function(e) {
              GeneralHelper.errorOut(e);
            });
          });
      });
    }
    return Cx.resolve();
  }

  static is_valid_pattern(p)
  {
    let valid = false;
    Cx_.forEach(p.Tags, function(t) {
      //valid = valid || ( t.Name.toUpperCase().indexOf(window.PatternBuilder.config().SETNAME.toUpperCase()) > - 1 ) ;
      valid = ( p.Class2 == 'vector' || p.Class2 == 'raster' ) ;
      valid = valid && p.Class2 !== 'header' ;
      valid = valid && p.Class2 !== 'logo' ;
    });
    return valid ;
  }

  static findValidTagName(tags)
  {
    return tags.find((n)=>n.Name.indexOf('/designer') >-1).Name ;
  }

  static load_pattern_and_metafiles (id, list_children) {
    View.wizardLoading(true, true, true);
    $("#patterns-container .pattern-select").removeClass("active");
    View.hide_logo_copyright();
    if(list_children)
      window.AppInstance.reset();
    return Pattern.load_pattern$(id, list_children).then(function(){
      return Favorites.reload_tuples$( window.AppInstance.instance().selected.ExternalParentID, 'pattern-favorite-sets' ).then(function() {
        $('#patterns-container .pattern-select[data-patternid="' + id + '"]').addClass("active");
        return MetaFiles.load_pattern_name_metafile$().then(function() {
          var tagName = Pattern.findValidTagName(window.AppInstance.instance().selected.Tags);
          return MetaFiles.load_metafiles_type$(tagName, Type.logo_document).then(function(logo){
            return MetaFiles.create_logo_metafile$(logo).then(function(){
              MetaFiles.render_floating_metafile$(window.AppInstance.instance().category_metafiles.logo, ".expanded-pattern .logo")
              if(!window.AppInstance.instance().is_raster)
              {
                View.build_colorpickers();
                ColorHelper.change_color($('.choose-color-swatch .promo-masonry .promos'), window.AppInstance.instance().doc_figures, true);
              }
              //$('#select-color').click();
              //update_ui();
              //wizardLoading(true, true, false); TODO: move to View
              View.update_preview_swatches();
              window.AppInstance.instance().jobData = {} //reset in case we've been processing a re-order
              $(".summary-pattern").html(window.AppInstance.instance().selected.name);
              return Pattern.render_pattern$(true).then(function() {
                View.wizardLoading(true, true, false);
                View.update_ui();
              });
            })
          })
        });
      });
    })
  }

  static update_vector_swatches(sender)
  {
    //selectedName, selectedHex
    window.AppInstance.instance().currentViewTransform = Cx.cloneDeep(window.AppInstance.instance().canvas.viewTransform) ;
    var id = JSON.parse(decodeURI(sender.id));
    var colors = JSON.parse(window.AppInstance.instance().selected.metadata.get('colorSet'))[id].Color ;
    if (!Cx.isArray(colors))
      colors = [colors];
    Pattern.update_pickers(colors);
    PatternBuilderCart.resetCartButton();
  }

  static update_pickers(colors)
  {
    var pickers = $('.choose-color-swatch .promo-masonry .promos') ;
    Cx_.forEach(pickers, function(picker, j){
      GeneralHelper.change_swatch(picker, colors[j].RGB, colors[j].ColorName);
    });
    ColorHelper.change_color(pickers);
    View.update_preview_swatches();
    Pattern.render_pattern$();
  }

  static load_pattern$(id, list_children) {

    let searchModel = {
      Owned: false,
      Shared: true,
      Archived: false,
      ExternalId: id
    }
    // this kills local storage of 10 MBs
    let hash = GeneralHelper.md5Encode(JSON.stringify(searchModel));

    var pattern = GeneralHelper.getPatternContainersFromLocalStorage('pattern', hash);

    if(pattern)
    {
      Cadx.Core.Document.read$(searchModel).then(function (pattern) {
        GeneralHelper.savePatternContainersToLocalStorage('pattern', hash, pattern);
      });
      return Pattern.handle_pattern_content$(pattern, list_children);
    }
    else {
      return Cadx.Core.Document.read$(searchModel).then(function (pattern) {
        GeneralHelper.savePatternContainersToLocalStorage('pattern', hash, pattern);
        return Pattern.handle_pattern_content$(pattern, list_children);
      });
    }
  }

  static handle_pattern_content$(pattern, list_children) {
    window.AppInstance.instance().selected.colors = [];
    window.AppInstance.instance().selected.parent = null ;
    window.AppInstance.instance().selected.id = pattern.Id;
    window.AppInstance.instance().selected.ExternalId = pattern.ExternalID ;
    window.AppInstance.instance().selected.Tags = pattern.Tags ;
    var doc = Cadx.Document.fromXmlString(pattern.Cdl);
    window.AppInstance.instance().doc = doc ;
    let doc_figures = doc.figures;
    window.AppInstance.instance().doc_figures = doc_figures ;

    return doc_figures[0].scale$(15, 15)
    .then(function() {
      return doc_figures[0].center$(Cx.Point(0, 0))
      .then(function() {
        window.AppInstance.instance().is_raster = Pattern.is_raster_pattern(doc_figures[0]) ;
        window.AppInstance.instance().selected.name = GeneralHelper.remove_extension(pattern.Name); //keep parent pattern name
        window.AppInstance.instance().selected.metadata = doc_figures[0].metadata ;

        var loadParentPromise;

        window.AppInstance.instance().ParentID = doc_figures[0].metadata.get('parentDocumentID');

        if ( ( window.AppInstance.instance().ParentID == undefined ) && ( window.AppInstance.instance().is_raster ) ) //parent raster
        {
          window.AppInstance.instance().selected.parent = Cx.Document.fromXmlString(pattern.Cdl);
          window.AppInstance.instance().selected.parent.id = pattern.Id;
          window.AppInstance.instance().selected.parent.ExternalId = pattern.ExternalID;
          window.AppInstance.instance().selected.parent.metadata = window.AppInstance.instance().selected.parent.figures[0].metadata;
        }

        if ( ( window.AppInstance.instance().ParentID && window.AppInstance.instance().selected.parent == null ) ) //children, parent not loaded, force load
          loadParentPromise = Pattern.load_parent_document$(window.AppInstance.instance().ParentID);
        else
        {
          window.AppInstance.instance().selected.rasterChildren = doc_figures[0].metadata.get("colorSet");
          loadParentPromise = Cx.resolve();
        }

        if ( ( window.AppInstance.instance().is_raster && window.AppInstance.instance().ParentID === undefined ) || ( !window.AppInstance.instance().is_raster ) ) //if it's raster and has parent id (meaning it's a child raster), keep the parents favorite state
        {
          window.AppInstance.instance().selected.is_favorite = Cx_.filter(window.AppInstance.instance().favorites, function(f) { return f.ExternalID === window.AppInstance.instance().selected.ExternalId }).length > 0 ;
          window.AppInstance.instance().selected.ExternalParentID = pattern.ExternalID ;
        }

        return loadParentPromise.then(function() {

          var md = (window.AppInstance.instance().ParentID) ? window.AppInstance.instance().selected.parent.metadata : window.AppInstance.instance().selected.metadata ;

          window.AppInstance.instance().selected.thumb_url = Thumbnail.get_thumb_url(window.AppInstance.instance().selected.id
            , null
            , false
            , md.get('thumbZoom')
            , md.get('thumbWidth')
            , md.get('thumbHeight')
            , md.get('thumbDPI')
          );

          //window.AppInstance.instance().path = Cx_.filter(pattern.Tags, function(t) { return t.Name.indexOf(window.PatternBuilder.config().SETNAME ) > -1 })[0].Name;
          //raster children are always private /FEBE-3806
          const search = window.PatternBuilder.config().SETNAME.replace("PRIVATE", "").replace("PUBLIC", "").replace("//","") ;
          var current_path = Cx_.filter(pattern.Tags, function(t) { 
            var tagName = t.Name ;
            // if ( window.AppInstance.instance().is_raster )
            //   tagName = tagName.replace("PRIVATE/", "PUBLIC/");
            t.Name = tagName;
            return ( t.Name.toUpperCase().indexOf(search) > -1 );
          });

          window.AppInstance.instance().path = ( current_path.length > 0 ) ? current_path[0].Name : window.PatternBuilder.config().SETNAME  ;

          let min_zoom_level = window.AppInstance.instance().canvas.zoom - 2;

          if (!window.AppInstance.instance().is_raster)
          {
            var color_zones = Cx.uniqueColorZones(doc_figures);
            window.AppInstance.instance().selected.original_zones = color_zones;
            ColorHelper.consolidate_color_zones();
            let initial_colorset = color_zones;
            let color_tuples = ColorHelper.get_spotcolor_tuples(doc.figures[0]);
            Thumbnail.list_color_thumbnails(window.AppInstance.instance().ParentID ? window.AppInstance.instance().ParentID : window.AppInstance.instance().selected.id, 'pattern-default-sets', color_tuples);
            return Cx.resolve();
          }
          else
          {
            if ( list_children )
            {
              return Pattern.list_raster_children_documents$('pattern-default-sets').then(function(){
                Pattern.load_variation(pattern.Id);
                return Cx.resolve();
              });
            } else {
              Pattern.load_variation(pattern.Id);
              return Cx.resolve();
            }
          }
        });
      });
    });
  }

  static render_pattern$(reset)
  {
    var md = (window.AppInstance.instance().ParentID) ? window.AppInstance.instance().selected.parent.metadata : window.AppInstance.instance().selected.metadata ;
    window.AppInstance.instance().canvas.document = window.AppInstance.instance().doc;
    if ( reset && reset !== undefined && reset === true )
    {
      window.AppInstance.instance().canvas.zoomTo(parseFloat(md.get('canvasZoom')));
      GeneralHelper.config_zoom_bar_update(parseFloat(md.get('canvasZoom')));
    }
    else if ( window.AppInstance.instance().currentViewTransform !== undefined ) {
      window.AppInstance.instance().canvas.zoomTo(window.AppInstance.instance().currentViewTransform.zoom, window.AppInstance.instance().currentViewTransform.center)
    }
    window.AppInstance.instance().rulerX.drawBar();
    window.AppInstance.instance().rulerY.drawBar();
    View.toggle_favorites_button();
    return window.AppInstance.instance().canvas.render$();
  }

  static load_variation(docId)
  {
    window.AppInstance.instance().selected.variationName = '';
    if ( ( window.AppInstance.instance().selected.parent != null ) && (window.AppInstance.instance().selected.rasterChildren != null ) )
    {
      if ( window.AppInstance.instance().selected.rasterChildren !== 'undefined' )
      {
        var variations = JSON.parse(window.AppInstance.instance().selected.rasterChildren);
        Cx_.forEach(variations, function(v){
          if ( v.Id == docId )
          {
            window.AppInstance.instance().selected.variationName = v.VariationName ;
          }
        });
      }
    }
    if ( window.AppInstance.instance().selected.variationName.length == 0 )
    {
      if ( window.AppInstance.instance().jobData !== undefined && window.AppInstance.instance().jobData.description !== undefined )
        window.AppInstance.instance().selected.variationName = window.AppInstance.instance().jobData.description.variationName ;
    }
    if ( window.AppInstance.instance().selected.variationName.length == 0 )
    {
      window.AppInstance.instance().selected.variationName = window.AppInstance.instance().selected.metadata.get('variationName');
    }
  }

  static load_parent_document$(parentID)
  {
    return Cadx.Core.Document.read$({
      Owned: false,
      Shared: true,
      Id: parentID,
      Archived: false
    }).then(function (parentPattern) {
      window.AppInstance.instance().selected
      var selectedParent = {}
      selectedParent.colors = [];
      selectedParent.id = parentPattern.Id;
      selectedParent.ExternalId = parentPattern.ExternalID;
      var parentDoc = Cadx.Document.fromXmlString(parentPattern.Cdl);
      var parentDocFigures = parentDoc.figures;
      return parentDocFigures[0].scale$(15, 15).then(function() {
        return parentDocFigures[0].center$(Cx.Point(0, 0)).then(function() {
          selectedParent.metadata = parentDocFigures[0].metadata;
          selectedParent.name = parentDoc.Name; //keep parent pattern name
          window.AppInstance.instance().selected.parent = selectedParent ;
          if (window.AppInstance.instance().selected.rasterChildren == null )
            window.AppInstance.instance().selected.rasterChildren = parentDocFigures[0].metadata.get('colorSet');
          return Cx.resolve();
          });
      });
    });
  }

  static is_raster_pattern (figure)
  {
    if ( figure.polyregions !== undefined )
      return ( figure.polyregions[0].brush.imageLink !== undefined );
    else
      return ( figure._imageLink !== undefined );
  }

  static get_base_color(pattern, index) {
    var colors = JSON.parse(window.AppInstance.instance().selected.metadata.get('colorSet'))[0].Color ;
    if ( ! Array.isArray( colors ) )
      return colors ;
    else
      return JSON.parse(window.AppInstance.instance().selected.metadata.get('colorSet'))[0].Color[index];
  }

  static get_custom_pattern_job_data_with_links$() {
    return Pattern.create_export_document$()
    .then(function(data) {
      var qs = {
        config: Cx.Core.getConfig()
        , model: {
          Doc: {
            Id: data.cxDocumentId
          }
        , PlainTextResult: false
        , FileName: 'export.pdf'
        }
        , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
      }

      var qs_thumb = {
        config: Cx.Core.getConfig()
        , model: {
          Doc: {
            Id: data.cxDocumentId
          }
          , Fit: true
        }
        , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
      }


      var job_data = Pattern.get_custom_pattern_job_data_object() ;
      job_data.cxDocumentId = data.cxDocumentId ;
      job_data.description.production_url = Cx.Core.getServer() + 'Core2/Doc/Export?' + encodeURIComponent(JSON.stringify(qs));
      job_data.description.thumb_url = Cx.Core.getServer() + 'Core2/Doc/Thumbnail?' + encodeURIComponent(JSON.stringify(qs_thumb));
      return Cx.resolve(job_data);
    });
  }

  static exportPatternBuilderJob$( job ) {

    const exportReq = Pattern.get_export_async_job_req(job);

    return fetch( Cx.Core.getServer() + "/Core2/Doc/ExportPatternBuilderCxJob", {
      method: "POST",
      body: JSON.stringify(exportReq)
    }).then((res)=>{
      console.log( "Export:", res.status, res.statusText )
      res.json()
      .then((exportRes)=>{
        console.log( JSON.stringify(exportRes, null, 2) )
        exportRes.ident = exportReq.ident
        return Cx.resolve(exportRes)
      })
    })
  }
  
  static checkExportPatternBuilderJob$( ident, jobId ) {
    return fetch( Cx.Core.getServer() + "/Core2/Doc/CheckExportPatternBuilderCxJob", {
      method: "POST",
      body: JSON.stringify(checkReq)
    })
    .then((res)=>{
      if ( res.status !== 200 ) {
        console.log( "Check:", res.status, res.statusText )
        throw new Error( `check failed ${res.status} #{res.statusText}` )
      }
      res.json()
      .then((checkRes)=>{
        return cx.resolve(checkRes)
      });
    })
  }

  static get_export_async_job_req(job) {

    var req = {
      config: Cx.Core.getConfig()
      , model: {
        CxJob: JSON.stringify(job)
      }
      , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
    }

    return req ;
  }

  static get_custom_pattern_job_data_object() {
    var meta_data = Pattern.get_metadata();
    if ( ! window.AppInstance.instance().is_raster )
    {
      //OriginalColorName, ReplacedColorName, OriginalColorHex, ReplacedColorHex
      meta_data.description.isRaster == false ;
      var swatches = $('.choose-color-swatch .promo-masonry .promos') ;

      Cx_.forEach(swatches, function(swatch, i) {
        meta_data.description.colors.push({
          OriginalColorName: $(swatch).find("input[name=origName]").val() ,
          OriginalHex: $(swatch).find("input[name=origHex]").val(),
          ReplacedColorHex: $(swatch).find("input[name=selectedHex]").val(),
          ReplacedColorName: $(swatch).find("input[name=selectedName]").val()
        });
      });

      //ColorHelper.change_color(swatches, figures);

      var color_tuple = ColorHelper.get_swatches_spotcolor_tuples(window.AppInstance.instance().doc_figures[0]);

      meta_data.color_tuple = color_tuple ;

      // meta_data.description.thumb_url = Thumbnail.get_thumb_url(window.AppInstance.instance().selected.id
      //   , color_tuple
      //   , true
      //   , window.AppInstance.instance().selected.metadata.get('thumbZoom')
      //   , window.AppInstance.instance().selected.metadata.get('thumbWidth')
      //   , window.AppInstance.instance().selected.metadata.get('thumbHeight')
      //   , window.AppInstance.instance().selected.metadata.get('thumbDPI')
      // );
    }
    //for raster patterns, a new document does not need to be created, the alternative colorset raster document id is passed
    else {
      meta_data.description.isRaster = true ;
      // meta_data.cxDocumentId = meta_data.description.productionDocumentID ;
      // meta_data.description.thumb_url = window.AppInstance.instance().selected.thumb_url ;
    }
    console.log(meta_data)
    return meta_data;
  }

  static create_export_document$() {

    var meta_data = Pattern.get_custom_pattern_job_data_object();

    //call Colorize with the given color replacements
    var createModel = {
      Id: meta_data.description.productionDocumentID,
      Tags: [{ Name: "/Imported", Shared: false, Owned: true}]
    }
    var optionsModel = {
      Colorize: { SpotColorTuples: meta_data.color_tuple, tagged: true },
      ExcludeDataOnResponse: true //only interested on ID
    }
    
    return Cx.Core.request$('Core2/Doc/CreatePatternBuilderColor', createModel, 'POST', null, optionsModel)
    .then(function (data) {
      meta_data.cxDocumentId = data.Id;
      return Cx.resolve(meta_data);
    });
  }

  static get_export_document_link$()
  {
    return Pattern.get_custom_pattern_job_data_with_links$()
    .then(function(data) {
      return Cx.resolve(data.description.production_url);
    });
  }


  static get_production_export_document_link$()
  {
    return Pattern.get_custom_pattern_job_data().then(function(data) {
      var qs = {
        config: Cx.Core.getConfig()
        , model: {
          Doc: {
            Id: data.cxDocumentId
          }
        , PlainTextResult: false
        , FileName: 'export.pdf'
        }
        , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
      }
      return Cx.resolve(Cx.Core.getServer() + 'Core2/Doc/Export?' + encodeURIComponent(JSON.stringify(qs)));
    });
  }

  static request_export_document$(url, params, callback ) {

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200)
      {
        var res = this.response;
        var reader = new window.FileReader();
        reader.readAsDataURL(res);
        reader.onloadend = function() {
          if(callback)
            callback(reader.result, 'Export.pdf');
        }
      }
    }
  
    xhr.open('POST', url );
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.send(JSON.stringify(params));
    xhr.responseType = 'blob';

  };

  static get_metadata(pattern) {
    var meta_data = {
      "cxJobType": "PatternBuilder",
      "cxDocumentId": "",
      "cxQuantity": 1,
      "description": {
        "colors": [],
        "pattern": window.AppInstance.instance().selected.name,
        "patternId": window.AppInstance.instance().selected.ExternalId.replace("production-", ""),
        "cadWorXId" : window.AppInstance.instance().selected.id,
        "material": "",
        "materialDescription": "",
        "color": 0,
        "colorDescription": "",
        "width": 0,
        "height": 0,
        "thumbnailWidth": window.AppInstance.instance().selected.metadata.get('thumbWidth'),
        "thumbnailHeight": window.AppInstance.instance().selected.metadata.get('thumbHeight'),
        "thumbnailDpi": window.AppInstance.instance().selected.metadata.get('thumbDPI'),
        "thumbnailZoom": window.AppInstance.instance().selected.metadata.get('thumbZoom'),
        "productionDocumentID": window.AppInstance.instance().selected.metadata.get('productionDocumentID'),
        "isRaster": false,
        "variationName": window.AppInstance.instance().selected.variationName,
        "selectedCategory": window.AppInstance.instance().selected.category
      }
    }

    return meta_data;
  }
}